import React, { Component } from 'react';
import config from 'react-global-configuration';

// Importação do Router
import { BrowserRouter, Route, Switch, Link, Redirect} from 'react-router-dom';
// Importação do Bootstrap
import { Button, Grid, Row, Col, Navbar, NavItem, Nav, MenuItem, NavDropdown } from 'react-bootstrap';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import Topo from '../Layout/Topo';
import RequestApi from '../Miscelania/RequestApi';
import Loading from '../Miscelania/Loading';
import Alerta from '../Miscelania/Alerta';

class QuestionsAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      name: '',
      number: '',
      setting_difficulty_id: '',
      content: '',
      multiple_choice: "1",
      active: "1",
      lista_dificuldades: [],
    };

    this.adicionar = this.adicionar.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  // Handlers de form
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }


  componentDidMount () {
    this.refs.request_api.verifyPermission();
    this.loadData();
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/questoes/dificuldade/listar';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/questoes');
        if (responseJson.status === 'success') {
          self.setState({lista_dificuldades: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/total/questoes';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({number: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */}); /* number question */
    });
  }

  adicionar(event) {
    event.preventDefault();
    var dados_salvar = {
      name: this.state.name,
      setting_difficulty_id: this.state.setting_difficulty_id,
      number: this.state.number,
      content: this.state.content,
      active: this.state.active,
      multiple_choice: this.state.multiple_choice,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/questao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          var url = '/questao/editar/' + responseJson.data.id;
          var storage = {
            mensagem_alerta: responseJson.message,
            tipo_alerta: responseJson.status,
          };
          localStorage.setItem("verifica_mensagem", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
        self.setState({mensagem_alerta: responseJson.message});
        self.setState({tipo_alerta: responseJson.status});
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    return (
<div>
  {(this.state.status_loading != 0) ? <Loading ativo={this.state.status_loading} desativar={this.desativar_loading} />: ""}
  {(this.state.status_alerta == 1) ? <Alerta mensagem={this.state.mensagem_alerta} tipo={this.state.tipo_alerta} desativar={this.desativar_alerta} /> : ""}
  <Topo></Topo>
  <RequestApi ref={'request_api'} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title pull-left">Cadastrar questão</h3>
      <Link to="/questoes" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.adicionar}>          
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Nome da questão:</label>
              <input type="text" name="name" className="form-control" placeholder="Nome da questão" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Número da questão:</label>
              <input type="text" disabled="disabled" name="number" className="form-control" placeholder="Número da questão" value={this.state.number} onChange={this.handleChange.bind(this, 'number')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Dificuldade de questão:</label>
              <Select
                className="form-field-name"
                name="setting_difficulty_id"
                value={this.state.setting_difficulty_id}
                searchable={true}
                placeholder={'Selecionar questão'}
                onChange={this.handleSelectChange.bind(this, 'setting_difficulty_id')}
                options={this.state.lista_dificuldades}
              />    
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Múltipla Escolha?</label>
              <Select
                className="form-field-name"
                name="multiple_choice"
                value={this.state.multiple_choice}
                searchable={true}
                placeholder={false}
                onChange={this.handleSelectChange.bind(this, 'multiple_choice')}
                options={[
                  {value: "0", label: "Não"},
                  {value: "1", label: "Sim"},
                ]}
              />    
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Ativa?</label>
              <Select
                className="form-field-name"
                name="active"
                value={this.state.active}
                searchable={true}
                placeholder={false}
                onChange={this.handleSelectChange.bind(this, 'active')}
                options={[
                  {value: "0", label: "Não"},
                  {value: "1", label: "Sim"},
                ]}
              />    
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Enunciado da questão:</label>
              <textarea style={{ height: 200 }} type="text" name="content" className="form-control" placeholder="Descrição" value={this.state.content} onChange={this.handleChange.bind(this, 'content')} />
            </div>
          </div>
        </div>
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Adicionar questão</button>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default QuestionsAdd;



// WEBPACK FOOTER //
// ./src/Components/Questions/QuestionsAdd.js